import { guardChildNodeByType, parseChildrenWithoutText, parseChildren } from '@utils/ast';
import { iframeComponentParsers } from './component.iframe.js';
import { imageComponentParsers } from './component.image.js';
import { mediaComponentParsers } from './component.media.js';
import { textComponentGlossaryWordParsers } from './component.text.glossary-words.js';
import { parseTextComponentHtmlNode, textComponentHtmlParsers } from './component.text.html.js';
import { textComponentLinkParsers } from './component.text.links.js';

const parseDiv = (node, context) => {
  if (node.classList.contains("row")) {
    return parseMedia(node, context);
  }
  if (node.classList.contains("table-responsive") && node.firstElementChild) {
    return parseTable(node.firstElementChild, context);
  }
  if (node.className.indexOf("element-type") === 0) {
    return parseSnippet(node, context);
  }
  if (node.classList.contains("snippet-highlight")) {
    return parseSnippetV2(node, context);
  }
  return parseTextComponentHtmlNode(node, context);
};
const parseMedia = (node, context) => {
  const mediaWrapper = node.querySelector(".complex-column");
  if (!mediaWrapper) {
    return null;
  }
  const divs = Array.from(mediaWrapper.childNodes).filter(
    guardChildNodeByType("div")
  );
  const firstDiv = divs.shift();
  const lastDiv = divs.pop();
  if (!firstDiv || !lastDiv) {
    return null;
  }
  const align = firstDiv.classList.contains("wrap-left") || lastDiv.classList.contains("wrap-left") ? "left" : "right";
  const [mediaDiv, childrenDiv] = firstDiv.className.includes("wrap-") ? [firstDiv, lastDiv] : [lastDiv, firstDiv];
  const media = parseChildrenWithoutText(
    mediaDiv,
    {
      ...imageComponentParsers,
      ...iframeComponentParsers,
      ...mediaComponentParsers
    },
    context.depth + 1
  );
  const children = parseChildren(
    childrenDiv,
    {
      ...textComponentHtmlParsers,
      ...textComponentLinkParsers,
      ...textComponentGlossaryWordParsers
    },
    context.depth + 1
  );
  return {
    nodeType: "text-component.media",
    options: {
      align
    },
    content: {
      children,
      media
    }
  };
};
const parseTable = (node, context) => {
  const children = parseChildrenWithoutText(
    node,
    textComponentHtmlParsers,
    context.depth + 1
  );
  return {
    nodeType: "text-component.table",
    options: {
      enableAlternativeLayout: node.classList.contains("table-alternative"),
      enableBorderedLayout: node.classList.contains("table-bordered"),
      enableHoverLayout: node.classList.contains("table-hover"),
      enableStripedLayout: node.classList.contains("table-striped")
    },
    children
  };
};
const parseSnippet = (node, context) => {
  return {
    nodeType: "text-component",
    id: void 0,
    pm2: {
      learningObjectId: void 0,
      learningObjectTitle: void 0,
      ribbonIconId: void 0,
      transcript: void 0,
      speechFileUrl: void 0,
      pdfFileUrl: void 0,
      pdfExport: void 0,
      enableLightboxButton: false,
      enableNewWindowButton: false,
      enableNotebookButton: false,
      isScrambled: false
    },
    meta: {
      caption: {
        title: void 0,
        description: void 0,
        caption: void 0,
        authorOrArtist: void 0,
        copyright: void 0,
        country: void 0,
        duration: void 0,
        year: void 0,
        numberOfPages: void 0
      },
      isRichText: true
    },
    options: {
      layout: void 0,
      autoCenter: false,
      isCollapsible: false,
      displayCaption: false
    },
    children: parseChildren(
      node,
      {
        ...textComponentHtmlParsers,
        ...textComponentLinkParsers,
        ...textComponentGlossaryWordParsers,
        ...textComponentDivParser,
        ...imageComponentParsers,
        ...iframeComponentParsers,
        ...mediaComponentParsers
      },
      context.depth + 1
    )
  };
};
const parseSnippetV2 = (node, context) => {
  return {
    nodeType: "text-component",
    id: void 0,
    pm2: {
      learningObjectId: void 0,
      learningObjectTitle: void 0,
      ribbonIconId: void 0,
      transcript: void 0,
      speechFileUrl: void 0,
      pdfFileUrl: void 0,
      pdfExport: void 0,
      enableLightboxButton: false,
      enableNewWindowButton: false,
      enableNotebookButton: false,
      isScrambled: false
    },
    meta: {
      caption: {
        title: void 0,
        description: void 0,
        caption: void 0,
        authorOrArtist: void 0,
        copyright: void 0,
        country: void 0,
        duration: void 0,
        year: void 0,
        numberOfPages: void 0
      },
      isRichText: true
    },
    options: {
      layout: "snippet",
      autoCenter: false,
      isCollapsible: false,
      displayCaption: false
    },
    children: parseChildren(
      node,
      {
        ...textComponentHtmlParsers,
        ...textComponentLinkParsers,
        ...textComponentGlossaryWordParsers,
        ...textComponentDivParser,
        ...imageComponentParsers,
        ...iframeComponentParsers,
        ...mediaComponentParsers
      },
      context.depth + 1
    )
  };
};
const textComponentDivParser = {
  div: parseDiv
};

export { textComponentDivParser };
//# sourceMappingURL=component.text.div.js.map
